import giftRuleApi from '@/api/gift-rule'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const LANGUAGES = ['ru', 'ky', 'en']

const today = () => new Date().toISOString().slice(0, 10)

const getDefaultState = () => ({
  id: 0,
  name: '',
  isEnabled: true,
  startsAt: today(),
  endsAt: null,

  triggerKind: 'MenuCategory',
  triggerCategoryRkId: null,
  triggerCategoryDeliveryGuid: null,
  triggerCategoryPath: null,
  triggerQuantity: 2,
  giftQuantity: 1,
  isCumulative: true,
  orderType: null,
  triggerDishRkIds: [],
  giftDishRkIds: [],

  defaultGiftDishRkId: null,
  translations: LANGUAGES.map(language => ({ language, name: '' })),

  resolution: null,

  dishOptions: [],
  categoryOptions: [],

  giftOptions: [],

  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  async fetchOptions({ commit }) {
    try {
      const { data } = await giftRuleApi.getOptions()
      commit('GIFT_RULE_OPTIONS_FETCHED', data)
    } catch {
      store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch')
    }
  },
  async fetchById({ commit }, id) {
    commit('FORM_RESET')
    try {
      const { data } = await giftRuleApi.getById(id)
      commit('GIFT_RULE_FETCHED', data)
    } catch {
      store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch')
    }
  },
  create({ commit }) {
    return giftRuleApi.create(payload())
      .catch(error => {
        commit('GIFT_RULE_SAVE_FAILED', error.response.data)
        throw error
      })
  },
  update({ commit }) {
    return giftRuleApi.update({ ...payload(), id: state.id })
      .catch(error => {
        commit('GIFT_RULE_SAVE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const payload = () => ({
  name: state.name,
  isEnabled: state.isEnabled,
  startsAt: state.startsAt,
  endsAt: state.endsAt,
  triggerKind: state.triggerKind,
  triggerCategoryRkId: state.triggerCategoryRkId,
  triggerCategoryDeliveryGuid: state.triggerCategoryDeliveryGuid,
  triggerCategoryPath: state.triggerCategoryPath,
  triggerQuantity: state.triggerQuantity,
  giftQuantity: state.giftQuantity,
  isCumulative: state.isCumulative,
  orderType: state.orderType,
  triggerDishRkIds: state.triggerDishRkIds,
  giftDishRkIds: state.giftDishRkIds,
  defaultGiftDishRkId: state.giftDishRkIds.includes(state.defaultGiftDishRkId)
    ? state.defaultGiftDishRkId
    : null,
  translations: state.translations.filter(x => x.name),
})

const mutations = {
  GIFT_RULE_OPTIONS_FETCHED(state, data) {
    state.dishOptions = data.dishes
    state.categoryOptions = data.categories
    state.giftOptions = data.gifts
  },
  GIFT_RULE_FETCHED(state, data) {
    Object.assign(state, data)

    state.translations = LANGUAGES.map(language => ({
      language,
      name: (data.translations || []).find(x => x.language === language)?.name || '',
    }))
  },
  GIFT_RULE_SAVE_FAILED(state, data) {
    state.errors = data?.validationErrors || {}
    store.dispatch('message/error', 'PUSH_NOTIFICATION.failedUpdate')
  },
  FORM_RESET(state) {
    const fresh = getDefaultState()

    fresh.dishOptions = state.dishOptions
    fresh.categoryOptions = state.categoryOptions
    fresh.giftOptions = state.giftOptions
    Object.assign(state, fresh)
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
